export default {
  APP_ROOT_PATH: '/',
  API_URL_LOCAL: 'http://localhost:8000/api',
  API_URL_UAT: 'https://d-ecouponapi.aidencreative.com/api',
  API_URL_PRODUCTION: 'https://d-ecouponapi.aidencreative.com/api',
  NO_RECORD_TEXT: 'No records found',
  USER_ROLE_SUPER_ADMIN: 'super_admin',
  USER_ROLE_ADMIN: 'admin',
  USER_ROLE_MERCHANT_ADMIN: 'merchant_admin',
  USER_ROLE_MERCHANT_USER: 'merchant_user',
  USER_ROLE_CUSTOMER: 'customer',
  STATUS_ACTIVE: 'Active',
  STATUS_INACTIVE: 'Inactive',
  ECOUPON_STATUS_ACTIVE: 'Active',
  ECOUPON_STATUS_ISSUED: 'Issued',
  ECOUPON_STATUS_REDEEMED: 'Redeemed',
  ECOUPON_STATUS_DELETED: 'Deleted',
  ECOUPON_STATUS_EXPIRED: 'Expired',
  ECOUPON_STATUS_CANCELLED: 'Cancelled',
  ECOUPON_STATUS_VOIDED: 'Voided',
  AUDITLOG_TYPE_ADMIN_USER: 'Admin User Creation and Deletion',
  AUDITLOG_TYPE_MERCHANT_USER: 'Merchant User Creation and Deletion',
  AUDITLOG_TYPE_ECOUPON_CODE_API: 'E-coupon Code API Call',
  AUDITLOG_TYPE_API_KEY_RESET: 'E-coupon API Key Reset',
  SETTING_KEY_MIN_BATCH_ECOUPON_REMINDER: 'min_batch_ecoupon_reminder',
} 



// WEBPACK FOOTER //
// ./src/config.js